export const catBtnStyles = {
	px: "20px",
	py: "12px",
	w: "full",
	variant: "ghost",
	justifyContent: "space-between",
	color: "gray.800",
	_active: {
		bg: "rgba(56, 88, 233, 0.05)",
		color: "primary.500",
		borderRadius: "4px",
	},
	fontSize: "13px",
};

export const typeBtnStyles = {
	variant: "unstyled",
	fontSize: "13px",
	fontWeight: "semibold",
	h: "full",
	px: "30px",
	borderRadius: "none",
	_active: {
		borderBottom: "2px",
		borderColor: "primary.500",
	},
};

export const scrollBarStyles = {
	"&::-webkit-scrollbar": {
		width: "4px",
		backgroundColor: "white",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: "gray.300",
		borderRadius: "8px",
	},
};
